import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogs-products',
  templateUrl: './catalogs-products.component.html',
  styleUrls: ['./catalogs-products.component.scss']
})
export class CatalogsProductsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
